export default {
    namespaced: true,

    state: {
        trimId: null,
        trimName: '',
        description: '',
        isSmallTrim: false,
        trimCreatedBy: null, // array[userId, userName]
        trimDateCreated: null,
        trimExportedBy: null, // array[userId, userName]
        trimDateExported: null,
        isTrimExported: false,
        permissionToEdit: false,
        trimIsOpenedBy: null,
        trimIsOpenedByUser: null,
    },

    getters: {
        
    },

    mutations: {
        setTrimId(state, id) {
            state.trimId = id;
        },

        setTrimName(state, name) {
            state.trimName = name;
        },

        setTrimDescription(state, description) {
            state.description = description;
        },

        setIsSmallTrim(state, isSmallTrim) {
            state.isSmallTrim = isSmallTrim;
        },

        setTrimCreatedBy(state, createdBy) {
            state.trimCreatedBy = createdBy;
        },

        setTrimDateCreated(state, date) {
            state.trimDateCreated = date;
        },

        setTrimExportedBy(state, exportedBy) {
            state.trimExportedBy = exportedBy;
        },

        setTrimDateExported(state, date) {
            state.trimDateExported = date;
        },

        setIsTrimExported(state, isTrimExported) {
            state.isTrimExported = isTrimExported;
        },

        setPermissionToEdit(state, permission) {
            state.permissionToEdit = permission;
        },

        setTrimIsOpenedBy(state, openedBy) {
            state.trimIsOpenedBy = openedBy;
        },

        setTrimIsOpenedByUser(state, userName) {
            state.trimIsOpenedByUser = userName;
        },
    },

    actions: {
        setTrimInfo({commit}, trim) {
            let { 
                id, 
                trimName,
                description,
                isSmallTrim,
                created_by, 
                date_created, 
                exported_by, 
                date_exported, 
                exported,
                permissionToEdit,
                opened_by,
                opened_byUser,
            } = trim;
            
            commit('setTrimId', id);
            commit('setTrimName', trimName);
            commit('setTrimDescription', description);
            commit('setIsSmallTrim', isSmallTrim);
            commit('setTrimCreatedBy', created_by);
            commit('setTrimDateCreated', date_created);
            commit('setTrimExportedBy', exported_by);
            commit('setTrimDateExported', date_exported);
            commit('setIsTrimExported', exported);
            commit('setPermissionToEdit', permissionToEdit);
            commit('setTrimIsOpenedBy', opened_by);
            commit('setTrimIsOpenedByUser', opened_byUser);
        },
    },
}